module.exports = __webpack_public_path__ + "img/deskshelf16.25cba782.jpg";